export default {
  title: '5050'
}

const Template = args => `
  <cradlepoint-5050
    image="${args.image}"
    image-position="${args.imagePosition}"
    background-color="${args.backgroundColor}"
    height="${args.height}"
    style="padding: 0;"
  >
  ${args.content}
  </cradlepoint-5050>
`;

export const WithCardSimpleText = Template.bind({});
export const WithCardQuoteA = Template.bind({});
export const WithCardQuoteB = Template.bind({});

WithCardSimpleText.args = {
  image: 'https://img.cradlepoint.com/auto-mapping-folder/2020/07/Piada-798x600-1.jpg',
  imagePosition: "left",
  backgroundColor: 'var(--cwc-color-secondary, #333F48)',
  height: "auto",
  content: `
    <cradlepoint-card-simple-text>
      <p class="text-white">
        Three links and multi-failover for critical comms at fixed sites
      </p>
      <p class="text-white">
        When healthcare or the ability to process payments hang in the balance,
        relying on just one type of WAN link isn't sufficient. A highly manageable
        solution that supports and intelligently orchestrates cellular, sattelite,
        and wired connectivity is the best way to stay flexible, no matter where
        the site is and what the applications are.
      </p>
    </cradlepoint-card-simple-text>
  `
}

WithCardQuoteA.args = {
  image: 'https://img.cradlepoint.com/auto-mapping-folder/2020/07/Piada-798x600-1.jpg',
  imagePosition: "left",
  backgroundColor: 'var(--cwc-color-secondary, #333F48)',
  height: "auto",
  content: `
    <cradlepoint-card-quote type="a">
      <p class="quote text-white">We are ready and waiting for 5G. We need next-gen mobile networking to run our next-gen applications.</p>
      <p class="attribution text-white"><span style="font-family:Eina01-Bold;">Bilfinger Global IT</span>, regional IT business partner</p>
    </cradlepoint-card-quote>
  `
}

WithCardQuoteB.args = {
  image: 'https://img.cradlepoint.com/auto-mapping-folder/2020/07/Piada-798x600-1.jpg',
  imagePosition: "left",
  backgroundColor: 'var(--cwc-color-secondary, #333F48)',
  height: "auto",
  content: `
    <cradlepoint-card-quote type="b" style="padding:0;">
    <p class="quote text-white">
      Our use of cellular broadband and Private LTE for on-site Point-of-Sale and
      guest service support has paved the way for new and innovative ways to interact
      with our guests and clients. Cradlepoint&apos;s solutions expanded the reach of our
      branch networks, resulting in even more engagement and unique experiences.
    </p>
    <p class="attribution text-white">
      <span style="font-family:Eina01-Bold;">Guest experience manager for Disney</span>
    </p>
    </cradlepoint-card-quote>
  `
}
